import { useTranslation } from 'react-i18next';

import {
    Button,
    Modal,
    ModalComponent,
    ModalProps,
    Typography,
} from '@speeki/global-ui-components';

import { useGuestLogin } from '@utils/hooks/useGuestLogin';

import { useSignUpModal } from '@services/AuthService/useSignUpModal';

import { useReactiveVar } from '@apollo/client';
import { guestLoginFormDataVar } from '@boot/reactiveVariables';

import {
    ListItem,
    ModalHeader,
    ModalList,
    PrivacyLink,
} from './TermsAndConditionsInfoModal.styled';

interface TermsAndConditionsInfoModalProps
    extends Pick<ModalProps, 'onClose' | 'open'> {}

export const TermsAndConditionsInfoModal = ({
    onClose,
    open,
}: TermsAndConditionsInfoModalProps) => {
    const { t } = useTranslation();

    const guestLoginData = useReactiveVar(guestLoginFormDataVar);

    const { loginGuest, sessionProcessing } = useGuestLogin();
    const { signUp, signUpData, signUpProcessing } = useSignUpModal();

    const loading = sessionProcessing || signUpProcessing;

    const listItems = [
        <>{t('BEFORE_GETTING_STARTED_INFO_1')}</>,
        <>{t('BEFORE_GETTING_STARTED_INFO_2')}</>,
        <>{t('BEFORE_GETTING_STARTED_INFO_3')}</>,
        <>
            {t('BEFORE_GETTING_STARTED_INFO_4')}{' '}
            <PrivacyLink
                href={'https://www.speeki.com/legal-stuff/privacy-policy'}
                target={'_blank'}
            >
                <Typography.TextBody_16_24>
                    {t('PRIVACY_POLICY')}
                </Typography.TextBody_16_24>
            </PrivacyLink>
        </>,
    ];

    return (
        <ModalComponent
            onClose={onClose}
            open={open}
            preventCloseEsc
            preventCloseOutside
            width={648}
        >
            <Modal.Content>
                <ModalHeader>
                    <Modal.TitleSecondary center>
                        {t('BEFORE_GETTING_STARTED_TEXT')}
                    </Modal.TitleSecondary>

                    <Modal.Description>
                        {t('BEFORE_GETTING_STARTED_INFO_TEXT')}:
                    </Modal.Description>
                </ModalHeader>

                <ModalList>
                    {listItems.map((item, index) => (
                        <ListItem key={index}>
                            <Typography.TextBody_16_24>
                                {item}
                            </Typography.TextBody_16_24>
                        </ListItem>
                    ))}
                </ModalList>
            </Modal.Content>
            <Modal.Footer>
                <Modal.ButtonsWrapper>
                    <Button
                        disabled={loading}
                        onClick={onClose}
                        testId="button_cancel"
                        variant={'secondary'}
                    >
                        {t('CANCEL')}
                    </Button>
                    <Button
                        disabled={loading}
                        isLoading={loading}
                        onClick={() => {
                            guestLoginData && void loginGuest(guestLoginData);
                            signUpData && void signUp();
                        }}
                        testId="button_agree"
                        variant={'primary'}
                    >
                        {t('AGREE')}
                    </Button>
                </Modal.ButtonsWrapper>
            </Modal.Footer>
        </ModalComponent>
    );
};
